<template>
  <b-modal
      title="ایجاد پلی‌لیست جدید"
      hide-footer
      id="modal-create-playlist"
      header-bg-variant="light"
      @hidden="resetForm"
      @ok="submit"
  >
    <b-form @submit.prevent="submit">
      <b-form-group label="عنوان" label-for="title">
        <b-form-input
            id="title"
            v-model="form.title"
            placeholder="مثلاً فصل اول"
            required
        />
      </b-form-group>

      <b-form-group label="توضیحات" label-for="description">
        <b-form-textarea
            id="description"
            v-model="form.description"
            placeholder="توضیحات این فصل"
            rows="3"
        />
      </b-form-group>

      <b-form-group label="ترتیب" label-for="sortOrder">
        <b-form-input
            id="sortOrder"
            v-model="form.sortOrder"
            type="number"
            placeholder="۰"
        />
      </b-form-group>

      <b-form-group>
        <b-form-checkbox v-model="form.isActive" switch>
          فعال
        </b-form-checkbox>
      </b-form-group>

      <div class="d-flex justify-content-end gap-2">
        <b-button variant="primary" type="submit" :disabled="submitting">
          <i class="fas fa-spinner fa-spin" v-if="submitting"></i>
          ایجاد
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BFormTextarea, BModal} from 'bootstrap-vue'
import {PlaylistCreateRequest} from '@/libs/Api/Playlist'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'CreatePlaylistModal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton
  },
  props: {
    ownerType: {
      type: Number,
      default: 1
    },
    ownerId: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visible: false,
      submitting: false,
      form: {
        title: '',
        description: '',
        sortOrder: 0,
        isActive: true
      }
    }
  },
  methods: {
    hide() {
      this.$bvModal.hide('modal-create-playlist')
    },
    resetForm() {
      this.form.title = ''
      this.form.description = ''
      this.form.sortOrder = 0
      this.form.isActive = true
      this.submitting = false
    },
    submit() {
      if (!this.form.title.trim()) {
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'خطا',
            icon: 'XIcon',
            variant: 'warning',
            text: 'لطفاً عنوان را وارد کنید.'
          }
        })
        return
      }

      this.submitting = true
      const data = {
        title: this.form.title,
        description: this.form.description,
        ownerType: this.ownerType,
        ownerId: this.ownerId,
        sortOrder: parseInt(this.form.sortOrder) || 0
      }

      const request = new PlaylistCreateRequest(this)
      request.setParams(data)
      request.fetch(
          (content) => {
            this.submitting = false
            this.hide()
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'موفق',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'پلی‌لیست با موفقیت ایجاد شد.'
              }
            })
            this.$emit('created', content)
            this.$bvModal.hide('modal-create-playlist')
            this.resetForm()
          },
          (error) => {
            this.submitting = false
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'خطا',
                icon: 'XIcon',
                variant: 'danger',
                text: error.message || 'مشکل در ایجاد پلی‌لیست'
              }
            })
          }
      )
    }
  }
}
</script>
